import React, { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';
import { useApp } from '../AppContext';
import LanguageSwitcher from '../components/LanguageSwitcher';
import Logo from '../components/Logo';
import { ArrowLeft, Printer, Download } from 'lucide-react';

const QrPage = () => {
  const navigate = useNavigate();
  const { t, lang, menu } = useApp();
  const canvasWrapRef = useRef(null);

  const url = typeof window !== 'undefined' ? window.location.origin : '';

  const download = () => {
    const canvas = canvasWrapRef.current?.querySelector('canvas');
    if (!canvas) return;
    const link = document.createElement('a');
    link.download = 'ilponticello-menu-qr.png';
    link.href = canvas.toDataURL('image/png');
    link.click();
  };

  const doPrint = () => window.print();

  return (
    <div className="relative min-h-screen w-full pt-6 pb-24 px-4">
      <div className="relative max-w-2xl mx-auto">
        <div className="flex items-center justify-between gap-2 mb-10 print:hidden">
          <button
            onClick={() => navigate('/')}
            className="w-10 h-10 flex-shrink-0 rounded-full border-[1.5px] border-black flex items-center justify-center hover:bg-black hover:text-white transition"
            aria-label={t('back')}
          >
            <ArrowLeft size={16} />
          </button>
          <Logo height={36} linkHome />
          <LanguageSwitcher />
        </div>

        <div id="qr-card" className="bg-white border-[1.5px] border-black rounded-[20px] p-8 md:p-12 text-center print:shadow-none print:rounded-none print:border-0">
          <div className="flex items-center justify-center mb-3">
            <Logo height={64} />
          </div>
          <div className="hairline w-10 mx-auto my-6" />
          <h1 className="font-display text-[38px] md:text-[54px] leading-[0.95] text-black">
            {lang === 'it' ? (<>Il <span className="font-serif-alt">nostro</span> Menù</>) : (<>Our <span className="font-serif-alt">Menu</span></>)}
          </h1>
          <p className="mt-3 text-black/70 font-medium">
            {lang === 'it' ? 'Inquadra il codice con il tuo smartphone' : 'Scan the code with your phone'}
          </p>

          <div ref={canvasWrapRef} className="mt-8 inline-block bg-white p-4 border-[1.5px] border-black rounded-2xl">
            <QRCodeCanvas
              value={url}
              size={280}
              bgColor="#FFFFFF"
              fgColor="#0A0A0A"
              level="H"
              includeMargin={false}
            />
          </div>

          <p className="mt-6 text-black/50 text-xs break-all">{url}</p>

          <div className="mt-4 text-black/80 text-sm font-semibold">
            {menu.restaurantInfo.address} • {menu.restaurantInfo.phone}
          </div>
        </div>

        <div className="mt-6 flex justify-center gap-3 print:hidden">
          <button onClick={doPrint} className="pill-btn primary">
            <Printer size={16} /> {t('print')}
          </button>
          <button onClick={download} className="pill-btn">
            <Download size={16} /> {t('downloadQr')}
          </button>
        </div>

        <p className="mt-6 text-center text-black/70 text-sm print:hidden">{t('qrDesc')}</p>
      </div>

      <style>{`
        @media print {
          body { background: white !important; }
          .App { background: white !important; }
        }
      `}</style>
    </div>
  );
};

export default QrPage;
